import { create } from "apisauce";
import { config } from "../app/config";

const http = create({
  baseURL: `${config.all.baseApi}/api`,
  withCredentials: true,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

export const httpSemBaseApi = create({});

let ipClient = {};

const getClientIp = async () => {
  const link1 = await httpSemBaseApi.get(`https://icanhazip.com/`);

  if (link1.ok && link1.data) {
    return { IPv4: link1.data.trim() };
  }

  const link2 = await httpSemBaseApi.get(`https://api.ipify.org/?format=json`);

  if (link2.ok && link2.data && link2.data.ip) {
    return { IPv4: link2.data.ip };
  }

  const link3 = await httpSemBaseApi.get(
    `https://geolocation-db.com/json/09ba3820-0f88-11eb-9ba6-e1dd7dece2b8`
  );

  if (link3.ok && link3.data) {
    return link3.data;
  }

  return null;
};

const login = async (email, password, token, clearance) => {
  const headers = {
    authorization: `Basic ${btoa(
      `${email.toUpperCase()}:${password.toUpperCase()}`
    )}`,
    ip: JSON.stringify(ipClient),
  };
  if (token) headers.token = token;
  if (clearance) headers.clearance = clearance;

  const loginResponse = await http.post("/authentication", {}, { headers });

  let sessionResponse;
  if (loginResponse.ok) {
    http.addRequestTransform((request) => {
      request.headers["X-Auth-Token"] = loginResponse.data.id;
    });
    sessionResponse = await session();
  }
  return {
    loginResponse,
    sessionResponse,
  };
};

const getContexts = async () => {
  const response = await http.get("/authentication/contexts");

  return response;
};

const getContextType = async (contextId) => {
  const { ok, status, data } = await http.get(
    `/authentication/contexts/classificacao/${contextId}`,
    {},
    { headers: { ip: JSON.stringify(ipClient) } }
  );

  return { ok, status, data };
};

const saveContext = async (contextId) => {
  const { ok, status, data } = await http.put(
    `/authentication/contexts/select/${contextId}`,
    {},
    { headers: { ip: JSON.stringify(ipClient) } }
  );

  return { ok, status, data };
};

export const session = async () => {
  const response = await http.get("/contrato/session");

  return response;
};

export const redisRefresh = (data) =>
  http.post(`/authentication/redis-refresh`, data);

export const getIsUserAuthenticated = async (user, pw) => {
  const response = await http.get(
    "/is-authenticated",
    {},
    {
      headers: {
        authorization: `Basic ${btoa(
          `${user.toUpperCase()}:${pw.toUpperCase()}`
        )}`,
        ip: JSON.stringify(ipClient),
      },
    }
  );
  return response;
};

export const sendContactType = async (contactType) =>
  await http.post("contrato/autenticacao-dois-fatores/tipo-contato", {
    tipoContato: contactType,
  },
  {
    headers: {
      // TODO: fixo consignet pois não é possivel determinar se é consignet ou mixtra antes do login do usuario, principalmente banco
      project: "CONSIGNET",
    },
  });

export const sendVerificationCode = async (verificationCode) =>
  await http.post("contrato/autenticacao-dois-fatores/validar-codigo", {
    codigoVerificacao: verificationCode,
  });

export const getUserTwoFactorData = async () =>
  await http.get("contrato/autenticacao-dois-fatores/dados-usuario");

export const getValidateCode = async () =>
  await http.get("contrato/autenticacao-dois-fatores/codigo-validado");

const Auth = {
  login,
  getClientIp,
  getContexts,
  saveContext,
  ipClient,
  getContextType,
  session,
  redisRefresh,
  getIsUserAuthenticated,
  sendContactType,
  sendVerificationCode,
  getUserTwoFactorData,
  getValidateCode,
};
export default Auth;
